import { apiConnector } from "../apiConnector";
import { toast } from "react-hot-toast";

import { schoolEndpoints } from "../apis";

const {
  GET_SCHOOL_BY_ID_API,
  CREATE_SCHOOL_API,
  GET_SCHOOLS_API,
  EDIT_SCHOOL_API,
  DELETE_SCHOOL_API,
  ADD_SCHOOL_ADMIN_API,
} = schoolEndpoints;

// ===================================================================
// GET SCHOOL BY ID
// ===================================================================
export const getSchoolBySchoolID = async (schoolId) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "GET",
      `${GET_SCHOOL_BY_ID_API}/${schoolId}`,
      null,
      { Authorization: `Bearer ${token}` }
    );

        //console.log("GET SCHOOL BY ID API :",response.data.data);
    return response.data.data || null;
  

  } catch (error) {
    // console.error("GET SCHOOL BY ID API ERROR:", error?.response?.data);
    // toast.error(
    //   error?.response?.data?.message || "Unable to fetch school details"
    // );
    return null;
  }
};


// ===================================================================
// CREATE SCHOOL
// ===================================================================
export const createSchool = async (formData, navigate) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST",
      CREATE_SCHOOL_API,
      formData,
      { Authorization: `Bearer ${token}` }
    );

    if (response.data.success) {
      toast.success("School created successfully");
      navigate("/dashboard/super-admin/schools");
      return true;
    } else {
      toast.error(response.data.message || "Failed to create school");
      return false;
    }
  } catch (error) {
    console.error("CREATE SCHOOL API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to create school"
    );
    return false;
  }
};


// ===================================================================
// GET ALL SCHOOLS
// ===================================================================
export const getSchools = async () => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "GET",
      GET_SCHOOLS_API,
      null,
      { Authorization: `Bearer ${token}` }
    );

    return response.data.data || [];

  } catch (error) {
    console.error("GET SCHOOLS API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to fetch schools"
    );
    return [];
  }
};


// ===================================================================
// EDIT SCHOOL
// ===================================================================
export const editSchool = async (formData) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "PUT",
      EDIT_SCHOOL_API,
      formData,
      { Authorization: `Bearer ${token}` }
    );

    if (response.data.success) {
      toast.success("School updated successfully");
      return true;
    } else {
      toast.error(response.data.message);
      return false;
    }
  } catch (error) {
    console.error("EDIT SCHOOL API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to edit school"
    );
    return false;
  }
};


// ===================================================================
// DELETE SCHOOL
// ===================================================================
export const deleteSchool = async (schoolId) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "DELETE",
      DELETE_SCHOOL_API,
      { schoolId },
      { Authorization: `Bearer ${token}` }
    );

    if (response.data.success) {
      toast.success("School deleted successfully");
      return true;
    } else {
      toast.error(response.data.message);
      return false;
    }

  } catch (error) {
    console.error("DELETE SCHOOL API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Failed to delete school"
    );
    return false;
  }
};


// ===================================================================
// ADD SCHOOL ADMIN
// ===================================================================
export const addSchoolAdmin = async (formData) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST",
      ADD_SCHOOL_ADMIN_API,
      formData,
      { Authorization: `Bearer ${token}` }
    );

    if (response.data.success) {
      toast.success("School admin created successfully");
      return true;
    } else {
      toast.error(response.data.message);
      return false;
    }

  } catch (error) {
    console.error("ADD SCHOOL ADMIN API ERROR:", error?.response?.data);
    toast.error(
      error?.response?.data?.message || "Unable to create school admin"
    );
    return false;
  }
};
